import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { ManageUsersContextProvider } from './ManageUsersContext';
import { TeamGroupModalContextProvider } from './TeamGroupModal/TeamGroupModalContext';

import ManageUsersLayout from './ManageUsersLayout';
import ManageUsersTabs from './ManageUsersTabs';
import { GroupMembersTable, TeamMembersTable } from './Tables';

const ManageUsersPage: React.FC = () => (
  <ManageUsersContextProvider>
    <TeamGroupModalContextProvider>
      <ManageUsersLayout>
        <Switch>
          <Route
            path="/users/list/group/:groupId"
            render={props => <GroupMembersTable {...props} />}
          />
          <Route
            path="/users/list/team/:teamId"
            render={props => <TeamMembersTable {...props} />}
          />
          <Route>
            <ManageUsersTabs />
          </Route>
        </Switch>
      </ManageUsersLayout>
    </TeamGroupModalContextProvider>
  </ManageUsersContextProvider>
);

export default ManageUsersPage;
